export const COLORS = [
    "#f00",
    "#a8326b",
    "#00f",
    "#f5a142",
    "#a84e32",
    "#064557",
    "#130f52",
    "#1e520f",
    "#1a0f52",
    "#3d0235",
    "#233d02",
    "#00693d",
    "#004878",
];
